import { Client } from '@/common/services/Client';

export async function downloadAttachment(id: number): Promise<Blob> {
  const response = await Client.get<Blob>({
    endpoint: `/attachments/${id}`,
    headers: {
      Accept: 'application/pdf',
    },
    responseType: 'blob',
  });
  return response.data;
}
